// @flow

const findElementBySelector = (selector: string): Node => document.querySelector(selector); // eslint-disable-line no-undef
const findElementById = (selector: string): Node => document.getElementById(selector); // eslint-disable-line no-undef

export {
	findElementBySelector,
	findElementById,
};
